import { SortDirection } from '@shared/types'

export const SORT_PRODUCTS: Record<
  string,
  { fieldName: string; value: string; direction: SortDirection }
> = {
  default: {
    fieldName: 'default',
    value: 'default',
    direction: SortDirection.ASC,
  },
  popular: {
    fieldName: 'popular',
    value: 'popular',
    direction: SortDirection.ASC,
  },
  by_date_of_receipt: {
    fieldName: 'name',
    value: 'name',
    direction: SortDirection.ASC,
  },
  cheaper_first: {
    fieldName: 'price',
    value: 'cheaper_first',
    direction: SortDirection.ASC,
  },
  more_expensive_first: {
    fieldName: 'price',
    value: 'more_expensive_first',
    direction: SortDirection.DESC,
  },
}
